"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var React = _interopRequireWildcard(require("react"));

var _reactNativeWeb = require("react-native-web");

var _StyleSheet = _interopRequireDefault(require("../../PlatformStyleSheet/StyleSheet"));

var _AaIcon = require("./AaIcon.model");

var _AaIconList = _interopRequireDefault(require("./AaIconList"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var AaIconComponent = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(AaIconComponent, _React$Component);

  var _super = _createSuper(AaIconComponent);

  function AaIconComponent(props) {
    (0, _classCallCheck2["default"])(this, AaIconComponent);
    return _super.call(this, props);
  }

  (0, _createClass2["default"])(AaIconComponent, [{
    key: "render",
    value: function render() {
      var _this = this;

      var iconName = this.props.controls.iconName || null;

      if (_reactNativeWeb.Platform.OS === "web") {
        var webIconLink = _AaIconList["default"].hasOwnProperty(iconName) && _AaIconList["default"][iconName].web;

        return /*#__PURE__*/React.createElement(_reactNativeWeb.View, null, iconName && !this.props.controls.onPress ? /*#__PURE__*/React.createElement(_reactNativeWeb.Image, {
          style: [styles.defaultImageStyle, this.props.controls.iconStyle],
          source: {
            uri: webIconLink
          }
        }) : null, iconName && this.props.controls.onPress ? /*#__PURE__*/React.createElement(_reactNativeWeb.TouchableWithoutFeedback, {
          accessible: this.props.controls.accessible !== null ? this.props.controls.accessible : true,
          onPress: function onPress() {
            return _this.props.controls.onPress();
          }
        }, /*#__PURE__*/React.createElement(_reactNativeWeb.View, {
          style: styles.touchableImageContainer
        }, /*#__PURE__*/React.createElement(_reactNativeWeb.Image, {
          style: [styles.defaultImageStyle, this.props.controls.iconStyle],
          source: {
            uri: webIconLink
          }
        }))) : null);
      }

      if (_reactNativeWeb.Platform.OS === "ios") {
        var mobileIcon = _AaIconList["default"].hasOwnProperty(iconName) && _AaIconList["default"][iconName].mobile;

        return /*#__PURE__*/React.createElement(_reactNativeWeb.View, null, iconName ? /*#__PURE__*/React.createElement(_reactNativeWeb.Image, {
          style: [styles.defaultImageStyleMobile, this.props.controls.iconStyle],
          source: mobileIcon
        }) : null);
      }

      if (_reactNativeWeb.Platform.OS === "android") {
        var _mobileIcon = _AaIconList["default"].hasOwnProperty(iconName) && _AaIconList["default"][iconName].mobile;

        return /*#__PURE__*/React.createElement(_reactNativeWeb.View, null, iconName ? /*#__PURE__*/React.createElement(_reactNativeWeb.Image, {
          style: [styles.defaultImageStyleMobile, this.props.controls.iconStyle],
          source: {
            uri: 'asset:/react_native/' + _mobileIcon
          }
        }) : null);
      }
    }
  }]);
  return AaIconComponent;
}(React.Component);

var styles = _StyleSheet["default"].create({
  defaultImageStyle: {
    minHeight: 16,
    minWidth: 16,
    marginRight: 10,
    marginLeft: 10,
    flex: 1,
    web: {
      resizeMode: 'stretch'
    }
  },
  touchableImageContainer: {
    web: {
      cursor: 'pointer'
    }
  },
  //TODO temporary solution
  defaultImageStyleMobile: {
    height: 16,
    width: 16,
    marginRight: 10,
    marginLeft: 10
  }
});

var _default = AaIconComponent;
exports["default"] = _default;